import request from "@/api/request";
import unionAxios from "@/utils/union-axios";
//首页查询个人/队伍打榜排名信息
export const chartRankingInfoList = (param) => {
  return request(
    `/web-h5/charge/rankingActivity/homePageRankingInfo`,
    param,
    "POST",
  );
};
//打榜个人排名信息
export const individualLeaderboard = (param) => {
  return request(
    `/web-h5/charge/rankingActivity/individualLeaderboard`,
    param,
    "POST",
  );
};

//打榜个人排名信息
export const teamLeaderboard = (param) => {
  return request(
    `/web-h5/charge/rankingActivity/teamLeaderboard`,
    param,
    "POST",
  );
};
//个人打榜活动报名
export const signUp = (param) => {
  return unionAxios.post(`/web-h5/charge/rankingActivity/signUp`, param);
};
//创建队伍
export const createTeam = (param) => {
  return unionAxios.post(`/web-h5/charge/rankingActivity/createTeam`, param);
};
//被邀请人加入队伍
export const joinTheTeam = (param) => {
  return unionAxios.post(`/web-h5/charge/rankingActivity/joinTheTeam`, param);
};
//被邀请人打开页面请求邀请信息
export const getInvitationMessage = (param) => {
  return unionAxios.post(
    `/web-h5/charge/rankingActivity/getInvitationMessage`,
    param,
  );
};
